import keyMirror from 'keymirror';

module.exports = keyMirror({
    SET_PLAYING: null,
    SET_SCENE: null,
    SET_PAGE: null,
    SET_FRAME_DONE: null,

    SET_HEADER_APPEARANCE: null,
    SET_MENU_OPEN: null,
    SET_SOUND_BAR_OPEN: null,
    SET_MASTER_VOLUME: null,
    SET_LANGUAGE: null,
    SET_MESSAGE_BOX_PLAYING: null,

    COMPLETE_SCENE: null,
    COMPLETE_INTERACTION: null,
    UNCOMPLETE_INTERACTION: null,
    UPDATE_SKIP_INTRO: null,
    LEARN_MORE_CHANGE: null,

    CRISIS_UPDATE_INTENSITY: null,
    CRISIS_UPDATE_CRISIS: null,
    CRISIS_UPDATE_SOUND: null,
    CRISIS_UPDATE_INSTABILITY: null,
    CRISIS_UPDATE_INSTABILITY_DELTA: null,

    USER_LOG_ADD: null,
    USER_LOG_CLEAR: null,
});



// WEBPACK FOOTER //
// ./js/constants/ActionTypes.js